import * as React from "react";
const SvgFiRrSpeedometerArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-speedometer-arrow_svg__a)">
      <path
        fill="#062147"
        d="M13.914 19.45c.051.176.086.358.086.55a2 2 0 1 1-2-2c.164 0 .321.025.474.062l3.795-3.795a.999.999 0 1 1 1.414 1.414l-3.768 3.77M21 12.112V6.077l1.293 1.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L21.28 3.528a1.82 1.82 0 0 0-2.56 0l-2.427 2.427a.999.999 0 1 0 1.414 1.414L19 6.076v4.196A11.74 11.74 0 0 0 13.583 8.1c-.194-.025-.388-.028-.583-.043V3.078l1.293 1.293a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L13.28.53a1.82 1.82 0 0 0-2.56 0L8.292 2.956A.999.999 0 1 0 9.707 4.37L11 3.077v4.97a12.04 12.04 0 0 0-6 2.212V6.077L6.293 7.37a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L5.28 3.528a1.82 1.82 0 0 0-2.56 0L.292 5.958A.999.999 0 1 0 1.707 7.37L3 6.078v6.001A12 12 0 0 0 0 20v.121c.023 2.14 1.818 3.88 4.002 3.88H7a1 1 0 1 0 0-2H4.002A1.99 1.99 0 0 1 2 20c0-2.497.937-4.889 2.598-6.72 2.48-2.593 5.806-3.576 8.73-3.195 2.3.295 4.43 1.46 5.988 3.137a10.2 10.2 0 0 1 2.168 3.666A9.8 9.8 0 0 1 22 20.083C21.99 21.14 21.091 22 19.996 22H17a1 1 0 1 0 0 2h2.996c2.188 0 3.984-1.749 4.003-3.899a11.8 11.8 0 0 0-.619-3.847 12.2 12.2 0 0 0-2.38-4.14z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-speedometer-arrow_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSpeedometerArrow;
